import { useContext } from 'react';
import { AuthContext } from './context';

export { AuthProvider } from './provider';
export type { AuthContextValue, AuthProfile, AuthProviderProps } from './types';

export const useAuth = () => useContext(AuthContext);
